export const defaultSendbirdGroupChannelUikitOptions = {
  enableVoiceMessage: true,
  enableMention: true,
  enableMarkAsUnread: true,
} as const;
